<!--
 * @Author: your name
 * @Date: 2020-06-18 15:23:47
 * @LastEditTime: 2020-06-23 16:48:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\views\DaTaoKeDetail.vue
--> 

<template>
	<div class="DaTaoKeDetail">
		<div class="DaTaoKeDetail_topFixed">
			<img
				src="../assets/lexianglogo.png"
				alt=""
			>
			<div class="DaTaoKeDetail_topFixed_center">
				<div>深度折扣</div>
				<div>购物先领券，省钱才赚钱</div>
			</div>
			<div class="DaTaoKeDetail_topFixed_button">下载App</div>
		</div>
		<img
			class="DaTaoKeDetail_banner"
			:src="itemDetail.img"
			alt=""
		>
		<div class="DaTaoKeDetail_title">
			<img
				:src="`${staticUrl}/image/dataoke/home/tianmao.png`"
				mode=""
				v-if="itemDetail.shoptype == 'B'"
			/>
			<img
				:src="`${staticUrl}/image/dataoke/home/taobao.png`"
				mode=""
				v-else
			/>
			{{itemDetail.title}}
		</div>
		<div class="DaTaoKeDetail_subheading">
			<div class="DaTaoKeDetail_subheading_left">
				<div class="DaTaoKeDetail_subheading_couponPrice">
					<p>券后价￥</p>
					<p>{{itemDetail.itemendprice}}</p>
				</div>
				<div class="DaTaoKeDetail_subheading_price">
					<p>原价</p>
					<p>￥{{itemDetail.itemprice}}</p>
				</div>
			</div>
			<div class="DaTaoKeDetail_subheading_right">
				<div>{{itemDetail.couponmoney}}元券</div>
				<div>{{itemDetail.couponendtime}}前有效</div>
			</div>
		</div>
		<div class="DaTaoKeDetail_password">
			<div class="DaTaoKeDetail_password_left">
				<p>购买口令：</p>
				<p>{{itemDetail.taoword}}</p>
			</div>
			<div class="DaTaoKeDetail_password_right">复制</div>
		</div>
		<div class="DaTaoKeDetail_last">复制购买口令，打开淘宝购买</div>
	</div>
</template>

<script>
import { staticUrl } from "@/config.js";
import { checkUserStatus } from "@/utils/login.js";
import api from "@/services/api.js";
export default {
	data() {
		return {
			staticUrl,
			itemDetail: {}
		};
	},
	mounted() {
		checkUserStatus(this.$route);
		this.getData();
	},
	methods: {
		async getData() {
			const { id } = this.$route.query;
			try {
				const res = await api.get("/api/v3/market/dataoke/taocode", {
					params: {
						item_id: id,
						title:
							"兔力不锈钢清洁膏家用厨房油污洗锅底黑垢去除除锈清洗剂强力去污"
					}
				});
				this.itemDetail = res.data.data;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.DaTaoKeDetail {
	box-sizing: border-box;
}
.DaTaoKeDetail_topFixed {
	box-sizing: border-box;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 1.47rem;
	background: #fff;
	display: flex;
	align-items: center;
	padding: 0 0.4rem;
	img {
		width: 1.07rem;
		height: 1.11rem;
		border-radius: 0.19rem;
		margin-right: 0.27rem;
	}
	.DaTaoKeDetail_topFixed_center {
		flex: 1;
		div:first-child {
			font-size: 0.45rem;
			font-weight: 400;
			color: black;
		}
		div:last-child {
			font-size: 0.33rem;
			color: #999;
			margin-top: 0.13rem;
		}
	}
	.DaTaoKeDetail_topFixed_button {
		width: 2.8rem;
		height: 0.8rem;
		text-align: center;
		line-height: 0.8rem;
		border-radius: 0.4rem;
		color: #fff;
		background-image: linear-gradient(to right, #fe4a45, #fe7f4a);
	}
}
.DaTaoKeDetail_banner {
	width: 100%;
	height: 10rem;
	margin-top: 1.47rem;
}
.DaTaoKeDetail_title {
	padding: 0 0.4rem;
	img {
		width: 0.67rem;
		height: 0.67rem;
		vertical-align:middle;
	}
	color: black;
	font-size: 0.45rem;
	line-height:.8rem;
	margin-top: 0.27rem;
}
.DaTaoKeDetail_subheading {
	margin-top: 0.87rem;
	display: flex;
	justify-content: space-between;
	padding: 0 0.4rem;
	.DaTaoKeDetail_subheading_left {
		flex: 1;
		.DaTaoKeDetail_subheading_couponPrice {
			p:first-child {
				display: inline-block;
				font-size: 0.27rem;
				color: #f81722;
			}
			p:last-child {
				display: inline-block;
				font-size: 0.5rem;
				color: #f81722;
				font-weight: bold;
			}
		}
		.DaTaoKeDetail_subheading_price {
			p:first-child {
				display: inline-block;
				margin-top: 0.27rem;
				font-size: 0.29rem;
				color: #999;
			}
			p:last-child {
				display: inline-block;
				margin-top: 0.27rem;
				font-size: 0.29rem;
				color: #999;
				text-decoration: line-through;
			}
		}
	}
	.DaTaoKeDetail_subheading_right {
		width: 2.33rem;
		border-radius: 0.19rem;
		overflow: hidden;
		position: relative;
		div:first-child {
			background-image: linear-gradient(to right, #fe4a45, #fe7f4a);
			border-bottom: 1px dashed #fff;
			line-height: 0.73rem;
			color: #fff;
			text-align: center;
			font-size: 0.32rem;
		}
		div:last-child {
			text-align: center;
			line-height: 0.48rem;
			background: #fdf0c7;
			color: #c84e29;
			font-size: 0.21rem;
		}
	}
	.DaTaoKeDetail_subheading_right::after {
		content: "";
		position: absolute;
		left: -0.135rem;
		top: 0.3rem;
		width: 0.27rem;
		height: 0.27rem;
		border-radius: 50%;
		background: #fff;
	}
	.DaTaoKeDetail_subheading_right::before {
		content: "";
		position: absolute;
		right: -0.135rem;
		top: 0.3rem;
		width: 0.27rem;
		height: 0.27rem;
		border-radius: 50%;
		background: #fff;
	}
}
.DaTaoKeDetail_password {
	margin-top: 0.67rem;
	background: #f4f4f4;
	display: flex;
	align-items: center;
	padding: 0.53rem 0.13rem 0 0.13rem;
	.DaTaoKeDetail_password_left {
		background: #fff;
		flex: 1;
		height: 1.6rem;
		line-height: 1.6rem;
		border-radius: 0.8rem;
		padding-left: 0.67rem;
		p:first-child {
			display: inline-block;
			color: #666;
			font-size: 0.35rem;
		}
		p:last-child {
			display: inline-block;
			font-size: 0.5rem;
			color: #666;
			font-weight: bold;
		}
	}
	.DaTaoKeDetail_password_right {
		background-image: linear-gradient(to right, #fe4a45, #fe7f4a);
		width: 2.2rem;
		height: 1.07rem;
		color: #fff;
		text-align: center;
		line-height: 1.07rem;
		margin-left: 0.27rem;
		border-radius: 1rem;
	}
}
.DaTaoKeDetail_last {
	background: #f4f4f4;
	color: #666;
	text-align: center;
	padding: 0.27rem 0 0.7rem 0;
}
</style>